(function() {
    'use strict';

    document.addEventListener('DOMContentLoaded', function() {
        const form = document.getElementById('ttgsb-form');
        if (!form) return;

        const cart = document.getElementById('ttgsb-cart');
        const cartList = document.getElementById('ttgsb-cart-list');
        const filterBtns = form.querySelectorAll('.ttgsb-filter-btn');
        const eventCards = form.querySelectorAll('.ttgsb-event-card');
        const slotLabels = form.querySelectorAll('.ttgsb-slot');

        // Flexform-Option: nur ein Slot pro Event auswählbar
        const singleSlotPerEvent = form.dataset.singleSlot === '1';

        // Slot-Auswahl
        slotLabels.forEach(function(label) {
            const input = label.querySelector('input[type="checkbox"]');
            if (!input || input.disabled) return;
            input.addEventListener('change', function() {
                // Bei aktivierter Option: andere Slots der gleichen Event-Karte abwählen
                if (singleSlotPerEvent && input.checked) {
                    const card = label.closest('.ttgsb-event-card');
                    if (card) {
                        card.querySelectorAll('.ttgsb-slot input[type="checkbox"]').forEach(function(other) {
                            if (other !== input && other.checked) {
                                other.checked = false;
                                const otherLabel = other.closest('.ttgsb-slot');
                                if (otherLabel) otherLabel.classList.remove('is-chosen');
                            }
                        });
                    }
                }
                label.classList.toggle('is-chosen', input.checked);
                updateCart();
            });
        });

        // Apple-Geräte (iOS/iPadOS/Mac): Adress-Links auf Apple Maps umbiegen.
        // No-JS bzw. alle anderen Geräte behalten den Google-Maps-Fallback aus dem Markup.
        const isAppleDevice = /iPad|iPhone|iPod/.test(navigator.platform || '') ||
            /Mac/.test(navigator.platform || '') ||
            (navigator.userAgent.indexOf('Mac') !== -1 && 'ontouchend' in document);
        if (isAppleDevice) {
            form.querySelectorAll('.ttgsb-event-address[data-ttgsb-maps-query]').forEach(function(link) {
                link.setAttribute('href', 'https://maps.apple.com/?q=' + link.dataset.ttgsbMapsQuery);
            });
        }

        // Modal-Elemente
        const modal = document.getElementById('ttgsb-modal');
        const proceedBtn = document.getElementById('ttgsb-proceed-btn');
        const modalSummaryEl = modal ? modal.querySelector('.ttgsb-modal-summary') : null;
        const modalSummaryList = document.getElementById('ttgsb-modal-summary-list');
        const modalSlotsContainer = document.getElementById('ttgsb-modal-slots');
        const bookingForm = document.getElementById('ttgsb-booking-form');
        const modalAlerts = document.getElementById('ttgsb-modal-alerts');
        const modalSuccess = document.getElementById('ttgsb-modal-success');
        let bookingSucceeded = false;

        function resetModal() {
            if (bookingForm) bookingForm.hidden = false;
            if (modalAlerts) { modalAlerts.hidden = true; modalAlerts.innerHTML = ''; }
            if (modalSuccess) modalSuccess.hidden = true;
            if (modalSummaryEl) modalSummaryEl.hidden = false;
            bookingSucceeded = false;
        }

        if (proceedBtn && modal) {
            proceedBtn.addEventListener('click', function() {
                const chosen = form.querySelectorAll('.ttgsb-slot.is-chosen');
                if (chosen.length === 0) return;

                resetModal();

                modalSummaryList.innerHTML = '';
                chosen.forEach(function(label) {
                    const card = label.closest('.ttgsb-event-card');
                    const eventTitle = card ? card.querySelector('.ttgsb-event-title').textContent.trim() : '';
                    const slotTitleEl = label.querySelector('.ttgsb-slot-title');
                    const slotTitle = slotTitleEl ? slotTitleEl.textContent.trim() : '';
                    const time = label.querySelector('.ttgsb-slot-time').textContent.trim();
                    const li = document.createElement('li');
                    li.textContent = eventTitle + (slotTitle ? ' – ' + slotTitle : '') + ' · ' + time;
                    modalSummaryList.appendChild(li);
                });

                modalSlotsContainer.innerHTML = '';
                form.querySelectorAll('input[name="slots[]"]:checked').forEach(function(input) {
                    const hidden = document.createElement('input');
                    hidden.type = 'hidden';
                    hidden.name = 'slots[]';
                    hidden.value = input.value;
                    modalSlotsContainer.appendChild(hidden);
                });

                modal.showModal();
            });
        }

        // Alle Schließen-Buttons (inkl. Success-Button)
        if (modal) {
            modal.querySelectorAll('.ttgsb-modal-close').forEach(function(btn) {
                btn.addEventListener('click', function() { modal.close(); });
            });
            modal.addEventListener('click', function(e) {
                if (e.target === modal) modal.close();
            });
            // Seite neu laden wenn Buchung erfolgreich abgeschlossen
            modal.addEventListener('close', function() {
                if (bookingSucceeded) {
                    window.location.reload();
                }
            });
        }

        // AJAX Formular-Submit
        if (bookingForm && modalAlerts && modalSuccess) {
            bookingForm.addEventListener('submit', function(e) {
                e.preventDefault();

                modalAlerts.hidden = true;
                modalAlerts.innerHTML = '';

                const submitBtn = bookingForm.querySelector('[type="submit"]');
                if (submitBtn) submitBtn.disabled = true;

                fetch(bookingForm.action, {
                    method: 'POST',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json'
                    },
                    body: new FormData(bookingForm)
                })
                    .then(function(res) { return res.json(); })
                    .then(function(data) {
                        if (data.success) {
                            bookingSucceeded = true;
                            bookingForm.hidden = true;
                            if (modalSummaryEl) modalSummaryEl.hidden = true;
                            modalAlerts.hidden = true;
                            modalSuccess.hidden = false;
                        } else {
                            var ul = document.createElement('ul');
                            ul.className = 'typo3-messages';
                            (data.errors || []).forEach(function(err) {
                                var li = document.createElement('li');
                                li.className = 'alert alert-danger';
                                var p = document.createElement('p');
                                p.className = 'alert-message';
                                p.textContent = err;
                                li.appendChild(p);
                                ul.appendChild(li);
                            });
                            modalAlerts.appendChild(ul);
                            modalAlerts.hidden = false;
                            modal.scrollTo({ top: 0, behavior: 'smooth' });
                            if (submitBtn) submitBtn.disabled = false;
                        }
                    })
                    .catch(function() {
                        if (submitBtn) submitBtn.disabled = false;
                    });
            });
        }

        // Filter
        filterBtns.forEach(function(btn) {
            btn.addEventListener('click', function() {
                filterBtns.forEach(function(b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
                btn.classList.add('is-active');
                btn.setAttribute('aria-pressed', 'true');
                const filter = btn.dataset.filter;
                eventCards.forEach(function(card) {
                    const hasFree = card.dataset.hasFree === '1';
                    card.style.display = (filter === 'available' && !hasFree) ? 'none' : '';
                });
            });
        });

        function updateCart() {
            const chosen = form.querySelectorAll('.ttgsb-slot.is-chosen');
            if (!cart || !cartList) return;

            cartList.innerHTML = '';
            chosen.forEach(function(label) {
                const card = label.closest('.ttgsb-event-card');
                const eventTitle = card ? card.querySelector('.ttgsb-event-title').textContent.trim() : '';
                const slotTitleEl = label.querySelector('.ttgsb-slot-title');
                const slotTitle = slotTitleEl ? slotTitleEl.textContent.trim() : '';
                const time = label.querySelector('.ttgsb-slot-time').textContent.trim();

                const li = document.createElement('li');
                const strong = document.createElement('strong');
                strong.className = 'ttgsb-cart-event';
                strong.textContent = eventTitle;
                li.appendChild(strong);

                if (slotTitle) {
                    const titleSpan = document.createElement('span');
                    titleSpan.className = 'ttgsb-cart-slot-title';
                    titleSpan.textContent = slotTitle;
                    li.appendChild(titleSpan);
                }

                const timeSpan = document.createElement('span');
                timeSpan.className = 'ttgsb-cart-time';
                timeSpan.textContent = time;
                li.appendChild(timeSpan);

                cartList.appendChild(li);
            });

            cart.hidden = chosen.length === 0;
        }
    });
})();
